module.exports = {
    'Book a viewing': 'Get in touch',
    close: 'Close',
    Title: 'Title*',
    Mr: 'Mr',
    Mrs: 'Mrs',
    Email: 'Email*',
    Firstname: 'First name*',
    Lastname: 'Last name*',
    Message: 'Message',
    Checkbox_updates: 'Tick to receive updates on other Andermatt Swiss Alps developments',
    Form_GDPR:
        'By submitting this form you agree to our <a href="https://www.andermatt-swissalps.ch/en/data-privacy-statement/" target="_blank">Privacy Policy</a>',
    'Privacy Policy': 'Privacy Policy',
    privacyLink: 'https://www.andermatt-swissalps.ch/en/data-privacy-statement/',
    Submit: 'Submit',
    Submiting: 'Submiting',
    'Title is required': 'Title is required',
    'First name must be at least 2 characters': 'First name must be at least 2 characters',
    'First name is required': 'First name is required',
    'Last name is required': 'Last name is required',
    'Last name must be at least 2 characters': 'Last name must be at least 2 characters',
    'Invalid email': 'Invalid email',
    'Email is required': 'Email is required',
    'Message is required': 'Message is required',
    'Thank you for getting in touch.': 'We have received your message and will be in touch with you shortly.',
    'There was an issue submitting the form.': 'There was an issue submitting the form.',
    'Scroll Down': 'Scroll Down',
    'Cookie settings': 'Cookie settings',
    CookiesMessage:
        'This website uses cookies, which help us to provide our services. By using our services, you consent to the setting of cookies by us.',
    'Learn more': 'Learn more',
    CookiesLink: 'https://www.andermatt-swissalps.ch/en/cookies',
    ACCEPT: 'ACCEPT',
    Brochure: 'Brochure',
    Available: 'Available',
    Reserved: 'Reserved',
    Sold: 'Sold',
    Residence: 'Residence',
    Unit: 'Unit',
    'Unit No.': 'Unit No.',
    Floor: 'Floor',
    Bedrooms: 'Bedrooms',
    Type: 'Type',
    Entrance: 'Entrance',
    'Sq. metres': 'Sq. metres',
    Size: 'Size',
    Balcony: 'Loggia',
    Availability: 'Availability',
    Floorplans: 'Floorplans',
    Price: 'Price',
    Download: 'Download',
    'Price list': 'Price list',
    Yes: 'Yes',
    No: '',
    'contact us': 'contact us',
    'View position in building': 'View position in building',
    'View floorplan': 'View floorplan'
}
